import { FooterLinksGroupModel } from '../../footer-links-group/FooterLinksGroup'

export const LINKS_GROUP_SET: FooterLinksGroupModel[] = [
  {
    title: 'Company',
    links: [
      { text: 'About', url: 'https://www.liveaction.com/company/' },
      { text: 'Our Team', url: 'https://www.liveaction.com/company/our-team/' },
      { text: 'Blog', url: 'https://www.liveaction.com/resources/#category-blog' },
      { text: 'Careers', url: 'https://www.liveaction.com/company/careers/' },
      { text: 'Press Release', url: 'https://www.liveaction.com/news-press-releases/' },
    ],
  },
  {
    title: 'Support',
    links: [
      { text: 'Contact Sales', url: 'https://www.liveaction.com/contact-sales/' },
      { text: 'Technical Support', url: 'https://www.liveaction.com/support/' },
      { text: 'Resources', url: 'https://www.liveaction.com/resources/' },
      { text: 'LiveAction 14-Day Trial', url: 'https://www.liveaction.com/download/' },
      { text: 'LiveNX Test Drive', url: 'https://www.liveaction.com/testdrive/' },
      {
        text: 'Omnipeek Trial',
        url: 'https://store.liveaction.com/product/omnipeek-network-protocol-analyzer/',
      },
      { text: 'Webinars', url: 'https://www.liveaction.com/resources/#category-videos' },
      {
        text: 'Training Program',
        url: 'https://www.liveaction.com/support/liveaction-training-program/',
      },
    ],
  },
  {
    title: 'Partners',
    links: [
      { text: 'Channel Partners', url: 'https://www.liveaction.com/partners/' },
      { text: 'Technology Partners', url: 'https://www.liveaction.com/partners/' },
    ],
    contacts: [
      {
        mail: 'partners@liveaction.com',
        tel: { value: '+18888811116', displayValue: '+1 888-881-1116' },
        fax: '+1 650-397-4131',
      },
    ],
  },
  {
    title: 'Contact',
    contacts: [
      {
        mail: 'support@liveaction.com',
        tel: { value: '+14082176501', displayValue: '+1 408-217-6501' },
        workingDays: 'Monday-Friday 6am-7pm PT except USA Holidays',
      },
      {
        mail: 'sales@liveaction.com',
        tel: { value: '+18888811116', displayValue: '+1 888-881-1116' },
      },
    ],
  },
]
